import { ArsContextState, IArsActionSetUIRequestStatus } from "../interface";

/**
 * Updates UI request status metadata.
 *
 * @param state - Current ARS context state
 * @param action - Set-UI-request-status action
 * @returns Updated state with request status changed
 */
export const arsc_setUiRequestStatus = <T>(
  state: ArsContextState<T>,
  action: IArsActionSetUIRequestStatus,
): ArsContextState<T> => ({
  ...state,
  uiRequestStatus: action.uiRequestStatus,
});
